import { BROKER_VERIFY_PIN, COMMON_SHOW_NOTIFICATION } from 'redux/actions';
import { IAction, IBrokerPhoneCode, INotification } from 'interfaces/common';
import { IBrokerVerifyPinParams } from 'interfaces/actions';
import { ToastType } from 'react-toastify';
import { call, put, takeLatest } from 'redux-saga/effects';
import { query } from 'utils/socketApi';
import config from 'config';

const queryBrokerVerifyPin = (params: IBrokerVerifyPinParams) => {
  return query(config.apis.equityBrokerVerifyPin, params);
};

function* doVerifyPin(request: IAction<IBrokerVerifyPinParams>) {
  try {
    const response: {
      data: { readonly result?: boolean };
    } = yield call(queryBrokerVerifyPin, {
      clientID: request.payload.clientID,
      pin: request.payload.pin,
    });

    if (request.response) {
      yield put<IAction<IBrokerPhoneCode>>({
        type: request.response?.success,
        payload: {
          pin: request.payload.pin,
          clientID: request.payload.clientID,
          isAuthorized: response.data.result,
          function: request.payload.brokerFunction,
        },
      });
    }
  } catch (error) {
    console.error('Broker verify pin failed', error);

    if (request.response) {
      yield put<IAction<string>>({
        type: request.response.failed,
        payload: error.code || error.message,
      });
    }

    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: 'Broker Verify Pin',
        content: error.code || error.message,
        contentParams: error.messageParams,
        time: new Date(),
      },
    });
  }
}

export default function* watchBrokerVerifyPin() {
  yield takeLatest(BROKER_VERIFY_PIN, doVerifyPin);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Common/BrokerFunction.ts